import validate from "/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import a0_45static_45assets_45global from "/src/app/middleware/a0.static-assets.global.ts";
import a1_45sso_45global from "/src/app/middleware/a1.sso.global.ts";
import a2_45bootstrap_45global from "/src/app/middleware/a2.bootstrap.global.ts";
import layout_45manager from "/src/modules/layout-manager/runtime/route-middleware.ts";
import direct_45app from "/src/modules/direct-app/runtime/route-middleware.ts";
import manifest_45route_45rule from "/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  a0_45static_45assets_45global,
  a1_45sso_45global,
  a2_45bootstrap_45global,
  layout_45manager,
  direct_45app,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/src/app/middleware/auth.ts"),
  "auto-add-item-to-basket": () => import("/src/app/middleware/auto-add-item-to-basket.ts"),
  "auto-apply-loyalty-program": () => import("/src/app/middleware/auto-apply-loyalty-program.ts"),
  "ensure-basket-is-loaded": () => import("/src/app/middleware/ensure-basket-is-loaded.ts"),
  "ensure-loyalty-is-loaded": () => import("/src/app/middleware/ensure-loyalty-is-loaded.ts"),
  "ensure-order-is-loaded-by-tracking-id": () => import("/src/app/middleware/ensure-order-is-loaded-by-tracking-id.ts"),
  "ensure-outlet-is-loaded": () => import("/src/app/middleware/ensure-outlet-is-loaded.ts"),
  "ensure-outlet-metadata-is-loaded": () => import("/src/app/middleware/ensure-outlet-metadata-is-loaded.ts"),
  guest: () => import("/src/app/middleware/guest.ts"),
  "validate-ordering-mode": () => import("/src/app/middleware/validate-ordering-mode.ts")
}